import { render } from "./Documentos.vue?vue&type=template&id=2aef26f0&scoped=true"
import script from "./Documentos.vue?vue&type=script&lang=js"
export * from "./Documentos.vue?vue&type=script&lang=js"

import "./Documentos.vue?vue&type=style&index=0&id=2aef26f0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aef26f0"]])

export default __exports__